import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BehaviorSubject, map, Observable} from 'rxjs';
import {Language} from 'src/app/interfaces/language.model';
import {ResponseModel} from 'src/app/interfaces/merchant';
import {PaginatedResult} from 'src/app/interfaces/response-model';
import {environment} from 'src/environments/environment';
import {MainDataService} from "./main-data.service";
import {TranslateService} from "@ngx-translate/core";

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  language = new BehaviorSubject('en');

  constructor(private http: HttpClient, private mainDataService: MainDataService, private translate: TranslateService) {
  }

  getLanguage(): Observable<{ languages: Language[] | undefined }> {
    return this.http.get<ResponseModel<PaginatedResult<Language>>>(`${environment.apiEndPoint}/Tenant/Language/GetAllLanguage`)
      .pipe(map(res => {
        let setLanguage;
        res.data?.records.forEach(childObj => {

          let lng = this.mainDataService.browserLanguge ? this.mainDataService.browserLanguge : localStorage.getItem("browserLanguage")

          if (lng == childObj.code) {

            setLanguage = childObj.code

          }


        });

        let defaultLanguage: any = res.data?.records.filter((lang: any) => lang.isDefault === true)
        if(!defaultLanguage.length && res.data?.records.length) {
          const nonDefaultLanguage = res.data?.records[0]
          localStorage.setItem('lang', nonDefaultLanguage.code);
          this.translate.setDefaultLang(nonDefaultLanguage.code);
          this.translate.use(nonDefaultLanguage.code);
        } else {
          const lang: any = setLanguage ? setLanguage : defaultLanguage[0]?.code;
          localStorage.setItem('lang', lang);
          this.translate.setDefaultLang(lang);
          this.translate.use(lang);
        }
        return {
          languages: res?.data?.records
        };
      }));
  }
}
